import { IconSVG } from '../types';

export const SkipNext = ({ size, style }: IconSVG) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      style={style}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M16.5 18V6H18.5V18H16.5ZM5.5 18V6L14.5 12L5.5 18Z" fill="currentColor" />
    </svg>
  );
};
